import * as React from 'react';
import { Link } from 'react-router-dom';
import {
  Container,
  List,
  ListItem,
  Box,
  Divider,
  Typography,
  Button,
} from '@mui/material';
import {Accordion , AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Popper from '@mui/material/Popper';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

const pages = ['About Us', 'Resources','Activities', 'E-Portals', 'Researcher Corner','Newspaper Clippings', 'OPAC', 'Contact'];


///Menu Names, items and links
const pageSubItems = {
 'About Us': {
    'Overview': '/Overview',
    'Facilities': '/facilities',
    'Collection':'/Collections',
    'Timings': '/Timings',
    'Rules and Regulations': '/Rules',
    'Dos and Don\'ts': '/DoNDont',
    'Services': '/Services',
    'Staff': '/Staffs',
  },
  'Resources': {
    'E-Resources': '/EResources',
    'UGC E-Books': 'https://www.ugc.gov.in/publication/ebook',
    'Open Access Resources': '/Files/OAR-Final.pdf',
    'Previous Years Question papers':'https://drive.google.com/drive/u/3/home',
    'VTU Syllabus':'https://vtu.ac.in/b-e-scheme-syllabus/'
  },
  'Activities': {
    'NDLI Club Activities': '',
    'Library Activities': '',
  },
  'E-Portals': {
    'NDLI': 'https://ndl.iitkgp.ac.in/',
    'Karnataka Digital Public Library': 'https://www.karnatakadigitalpubliclibrary.org/',
    'Online Certification Courses': '/Files/Online Certification.pdf',
    'SWAYAM': 'https://swayam.gov.in/',
    'NPTEL': 'https://nptel.ac.in/',
    'GIAN':'https://gian.iitkgp.ac.in/',
    'E-PG Pathashala': 'https://epgp.inflibnet.ac.in/',
  },
 'Researcher Corner': {
    'ORCID': 'https://orcid.org/register',
    'Web of Science Researcher ID': 'https://access.clarivate.com/register?app=wos',
    'Google Scholar': 'https://scholar.google.com/',
    'Research Gate': 'https://www.researchgate.net/login',
    'Academia.edu': 'https://www.academia.edu/signup',
    'Vidwan': 'https://vidwan.inflibnet.ac.in/',
    'Mendeley': 'https://www.mendeley.com/?interaction_required=true',
    'Zotero': 'https://www.zotero.org/user/register',
    'Linkedin': 'https://www.linkedin.com/',
  },



  'Contact': {
    "Librarian: Ramanjineya.lb@hkbk.edu.in": '',
    "Office: library@hkbk.edu.in": '',
    "Phone: 08025441722":'',
    
  },

};


// Image link for correspoding Menu names
const ImgList={
  'About Us': '/imgs/library1.jpg',

  'Resources': '/imgs/library1.jpg',

  'Activities': '/imgs/library1.jpg',

  'E-Portals': '/imgs/library1.jpg',

  'Researcher Corner': '/imgs/library1.jpg',

  'Contact': '/imgs/library1.jpg',
}


const drawerWidth = 240;

function Navbar(props) {
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popperContent, setPopperContent] = React.useState(null);
  const [popperImg, setPopperImg] = React.useState(null)


  const navColor = props.NavColor || "secondary.dark";

  const onHover = (event, title) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
    setPopperContent(pageSubItems[title]); // Update popper content based on title
    setPopperImg(ImgList[title]) // update image link for the popper
    
  };


  const offHover = () => {
    setOpen(false);
    setAnchorEl(null);
    setPopperContent(null); // Clear popper content on mouseleave
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? 'transition-popper' : undefined;


  const handlePdfDownload = (pdfUrl) => {
    const anchorElement = document.createElement('a');
    anchorElement.href = pdfUrl;
    anchorElement.download = pdfUrl.split('/').pop(); // Extract filename from path
    anchorElement.click();
  };



  // *************Mobileview Items



  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };


  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };


  const drawer = (
    <Box sx={{ textAlign: 'center'  }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        HKBK Library
      </Typography>
      <Divider />
      
      {pages.map((title, key) => (
        <Accordion  key={key} expanded={expanded === title} onChange={handleChange(title)}>
        <Grid>
        {title === 'OPAC' ? (
                // Exception for OPAC Menu
                <Link  to="http://172.17.3.9/opac/Search.aspx" onClick={null} onMouseEnter={offHover}>
                  <Typography textAlign={'left'} p={2} color={'secondary.main'}  fontWeight={'bold'}>
                    {title}
                  </Typography>
                </Link>
              ) : title === 'Newspaper Clippings' ? (
                // Exception for Newspaper Clippings
                <Link to="https://drive.google.com/drive/folders/1zq1S5lK415xgjEISaFhIHfvuH_rp3Dwi?usp=sharing" onClick={null} onMouseEnter={offHover}>
                  <Typography textAlign={'left'} p={2} color={'secondary.main'} fontWeight={'bold'}>
                    {title}
                  </Typography>
                </Link>
              ) : (
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{fontWeight:600,
              color:'secondary.main'
            }}
          >
            {title}
          </AccordionSummary>
          )}
        </Grid>
        {Object.entries(pageSubItems[title] || {}).map(([subItemName, subItemLink]) => (
            <AccordionDetails key={subItemName}>
              
                  <Link to={subItemLink}>
                  <ListItem 
                    sx={{ color: 'secondary.main' }}
                  >
                      {subItemName}
                  </ListItem>
                  </Link>
                  <Divider sx={{ mx: 2 }} />
                      
            </AccordionDetails>
         ))}
        </Accordion>
        ))}
      
      <List >
      
        
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;





  return (
    <Grid>
      <Grid sx={{backgroundColor: navColor, display:'flex', justifyContent:'flex-end',m:0, pt: 2,}}>
        <Link to={'https://forms.gle/sTyzntM1PMUZUn3q9'}>
          <Button sx={{color:'secondary.light', backgroundColor:'primary.light', mr:2}}>
            Library Membership Form
          </Button>
        </Link>
      </Grid>
      <Grid container onMouseLeave={offHover} sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent:'space-between',
        width: 1,
        backgroundColor: navColor,
        flexWrap:'nowrap',
        mx: 0,
        my:0,
        pt:0,
        pb:2
      }} >
      
        <Grid item xs={4} md={2}>
      
          <Link to={'/'}>
            <Container  component={'img'} src={'/imgs/HKBKLogo.png'} sx={{ width: '100%', m: 0, p: 0, alignSelf:'center' }} />
          </Link>
        </Grid>
      {/* Mobile View */}
      <Toolbar>
            <IconButton
              color="primary"
      
              onClick={handleDrawerToggle}
              sx={{  display: { xl: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
      
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            anchor={'right'}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', xl: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
      
        {/* Destop view */}
        <Grid item md={9} sx={{display:{xs:'none',xl:'block'}}}>
          <Grid container wrap='nowrap' sx={{ display: 'flex', alignItems:'center', justifyContent:'space-between', color: 'primary.main' }}>
            {pages.map((title, key) => (
              <div key={key} >
                <Grid item
                  sx={{ textTransform: 'uppercase', whiteSpace:'nowrap', p:1  }}
                   // Pass title to onHover
                > {title === 'OPAC' ? (
                  // Exception for OPAC Menu
                  <Link to="http://172.17.3.9/opac/Search.aspx" onClick={null} onMouseEnter={offHover}>
                    <Typography  color={'primary.main'} fontWeight={'bold'}>
                      {title}
                    </Typography>
                  </Link>
                ) : title === 'Newspaper Clippings' ? (
                  // Exception for Newspaper Clippings
                  <Link to="https://drive.google.com/drive/folders/1zq1S5lK415xgjEISaFhIHfvuH_rp3Dwi?usp=sharing" onClick={null} onMouseEnter={offHover}>
                    <Typography  color={'primary.main'} fontWeight={'bold'}>
                      {title}
                    </Typography>
                  </Link>
                ): (
                  // Display the Navbar menu items for other titles
                  <Grid item   sx={{ display: 'flex', alignItems: 'center' }} onMouseEnter={(e) => onHover(e, title)}>
                    <Typography  fontWeight={'bold'}>
                      {title}
                    </Typography>
                    <ArrowDropDownIcon />
                  </Grid >
                )}
                  {/* Popper Components */}
                  <Popper id={id} open={open} anchorEl={anchorEl} transition>
      
                        {popperContent && ( // Render popper content only if it exists
                          <Container sx={{ position:'absolute', top:130, left:300, display: 'flex', p: 1, width: '60vw', bgcolor: 'background.paper', boxShadow: '0px .5px 15px rgba(c, c, c, 0.25)'}}>
                            <Box component={'img'} src={popperImg } sx={{p:2,aspectRatio:1/1, width:'30%', height:'auto', objectFit:'contain', border:' solid 3px #8c0900' }} />
                             <List sx={{ width: '75%' }}>
                              {/* Rendering Subitems and item link by mapping */}
                              {Object.entries(popperContent).map(([subItemName, subItemLink]) => (
                                <div key={subItemName}>
                                  {subItemName === 'Open Access Resources' ? (
                                    <ListItem sx={{
                                      color: 'secondary.main',
                                      fontWeight: 'bold',
                                      '&:hover': { color: 'primary.main', backgroundColor: 'primary.dark' },
                                    }}
                                    onClick={() => handlePdfDownload(subItemLink)}>
                                      Open Access Resources
                                    </ListItem>
                                  ) : subItemName === 'Online Certification Courses' ? (
                                    <ListItem
                                    sx={{
                                      color: 'secondary.main',
                                      fontWeight: 'bold',
                                      '&:hover': { color: 'primary.main', backgroundColor: 'primary.dark' },
                                    }}
                                     onClick={() => handlePdfDownload(subItemLink)}>
                                      Online Certification Courses
                                    </ListItem>
                                  ): subItemName === 'NDLI Club Activities' ? (
                                    
                                    <Accordion >
                                    <AccordionSummary
                                    sx={{
                                      color: 'secondary.main',
                                      fontWeight: 'bold',
                                      '&:hover': { color: 'primary.main', backgroundColor: 'primary.dark' },
                                    }}
                                      expandIcon={<ExpandMoreIcon />}
                                    >
                                      NDLI Activities
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <ListItem dense 
                                      sx={{
                                        color: 'secondary.main',
                                        fontWeight: 'bold',
                                        '&:hover': { color: 'primary.main', backgroundColor: 'primary.dark' },
                                      }}
                                       onClick={() => handlePdfDownload(subItemLink)}>
                                         • 2024
                                      </ListItem>
                                    </AccordionDetails>
                                  </Accordion>
                                   
                                  ):  (
                                    <Link to={subItemLink}>
                                      <ListItem
                                        sx={{
                                          color: 'secondary.main',
                                          fontWeight: 'bold',
                                          '&:hover': { color: 'primary.main', backgroundColor: 'primary.dark' },
                                        }}
                                      >
                                        {subItemName}
                                      </ListItem>
                                    </Link>
                                  )}
                                  <Divider sx={{ mx: 2 }} />
                                </div>
                              ))}
                            </List>
                          </Container>
                        )}
                  </Popper>
                </Grid>
      
              </div>
              ))}
          </Grid >
        </Grid>
      
      
      
            </Grid>
    </Grid>

  );
}
export default Navbar;
